import Layout from '@/components/Layout'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Building2, Settings } from 'lucide-react'
import { useCallback } from 'react'
import { DadosEmpresaTab } from './DadosEmpresaTab'
import { ParametrosTab } from './ParametrosTab'
import { SistemaTab } from './SistemaTab'

const Configuracoes = () => {
  const getIdEmpresa = useCallback((): number | null => {
    try {
      const userStr =
        localStorage.getItem('auth_user') || sessionStorage.getItem('auth_user')
      if (userStr) {
        const user = JSON.parse(userStr)
        return user.id_empresa || null
      }
    } catch (error) {
      console.error('Erro ao obter id_empresa:', error)
    }
    return null
  }, [])

  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h2 className="text-3xl font-bold tracking-tight text-foreground">
            Configurações
          </h2>
          <p className="text-muted-foreground mt-1">
            Gerencie as configurações do sistema
          </p>
        </div>

        <Tabs defaultValue="empresa" className="w-full">
          <TabsList>
            <TabsTrigger value="empresa" className="gap-2">
              <Building2 className="h-4 w-4" />
              Dados da Empresa
            </TabsTrigger>
            {/* <TabsTrigger value="empresas" className="gap-2">
              <Building2 className="h-4 w-4" />
              Empresas
            </TabsTrigger> */}
            <TabsTrigger value="parametros" className="gap-2">
              <Settings className="h-4 w-4" />
              Parâmetros
            </TabsTrigger>
            <TabsTrigger value="sistema">Sistema</TabsTrigger>
          </TabsList>

          <TabsContent value="empresa" className="space-y-4">
            <DadosEmpresaTab getIdEmpresa={getIdEmpresa} />
          </TabsContent>

          {/* <TabsContent value="empresas" className="space-y-4">
            <EmpresasTab />
          </TabsContent> */}

          <TabsContent value="parametros" className="space-y-4">
            <ParametrosTab getIdEmpresa={getIdEmpresa} />
          </TabsContent>

          <TabsContent value="sistema" className="space-y-4">
            <SistemaTab getIdEmpresa={getIdEmpresa} />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  )
}

export default Configuracoes
